import {field} from '../field'
import {define} from '../../fieldsets'
import {mergeConfig} from '../../configStore'
import type {ImageField, FieldReturn} from '../../types'

const defaultProps: Partial<ImageField> = {
  fieldsets: [define('meta', {title: 'Metadata'})],
  fields: [
    field('string', {
      name: 'altText',
      description: 'Overrides the image alt text set in the Media Gallery.',
      fieldset: 'meta',
    }),
  ],
  options: {
    hotspot: true,
    collapsible: false,
  },
}

export const image = (props?: ImageField, mergeProps?: Partial<ImageField>): FieldReturn =>
  field('image', mergeConfig('image', props, mergeProps, defaultProps))
